import * as icons from '../../assets/icons';
import * as permissions from '../../config/permissions';

const navConfig = [
  // {
  //   title: 'Home',
  //   path: '/aisle/home',
  //   icon: icons.HomeIcon,
  // },
  // {
  //   title: 'Active list',
  //   path: '/aisle/list',
  //   icon: icons.ActiveListIcon,
  //   permission: permissions.PERM_AISLE_ACTIVE_LIST,
  // },
  // {
  //   title: 'Analyze',
  //   path: '/aisle/results',
  //   icon: icons.AnalyzeAisle,
  //   permission: permissions.PERM_AISLE_STATS_PERMISSION,
  // },
  {
    title: 'Market Stream',
    // new: true,
    path: '/aisle/market-stream',
    icon: icons.MarketStream,
    permission: permissions.PERM_AISLE_STATS_PERMISSION,
  },
];

export default navConfig;
